import 'bootstrap/dist/css/bootstrap.min.css'

import Documentos from './Components/Documentos'
import Header from './Components/Header'
import Banner from './Components/Banner'
import Avisos from './Components/Avisos'
import Passos from './Components/Passos'
import Footer from './Components/Footer'
import React from 'react'

const App = () => {
  document.title = 'Rematrícula UNIFTC 2025.1'

  return (
    <div className='App'>
      <Header />
      <Banner />
      <Avisos />
      <Passos />
      <Documentos />
      <Footer />
    </div>
  )
}

export default App
